import { gql } from '@apollo/client';

export const CREATE_REPORT_MUTATION = gql`
mutation createReport($reportType: String!) {
    createReport(input: { reportType: $reportType }) {
      id
      status
    }
  }
`;